import type { ComponentType } from 'react';

import type { ExtensionParams } from '@atlaskit/editor-common/extensions';
import type {
	Alignment,
	CornerStyle,
	ExtensionMode,
	Orientation,
	ProductDependenciesProviderProps,
	UpdateMainFormFieldType,
} from '@atlassian/company-hub-common';
import type { SIZE_VALUES } from '@atlassian/company-hub-common/config-panel';

import type { SourceType } from './constants';
import type { HelpObjectStoreEntityTypes } from './controllers/use-jsm-help-entities/__generated__/useJsmHelpEntitiesJsmHelpEntitiesPaginationRootQuery.graphql';

export enum SubEntityTypes {
	REQUEST_TYPES = 'REQUEST_TYPES',
	KB_ARTICLES = 'KB_ARTICLES',
	EXT_RESOURCES = 'EXT_RESOURCES',
}

export enum HelpCenterSortMode {
	PARENT = 'PARENT',
	SUB_ENTITY_TYPE = 'SUB_ENTITY_TYPE',
	MANUAL = 'MANUAL',
}

export type JSMHelpExtensionProps = {
	contentId: string;
	extensionNode: ExtensionParams<JSMHelpParameters>;
	mode: ExtensionMode;
	propsProvider: ComponentType<ProductDependenciesProviderProps>;
};

export type ProductEntitiesFilter = {
	parentId: string;
	subEntityTypes: HelpObjectStoreEntityTypes[];
};

export type HelpItem = {
	displayLink?: string | null;
	iconUrl?: string | null;
	id: string;
	name?: string | null;
	subEntityType: HelpObjectStoreEntityTypes;
};

export type EntityData = {
	[key: string]: {
		[key: string]: {
			imageAltText: string;
			imageSrc: string;
		};
	};
};

export type ProductEntitySortConfig = {
	additionalConfig: {
		manualSortOrder: string[];
	};
	sortMode: HelpCenterSortMode;
};

export type JSMHelpParameters = {
	alignment: Alignment;
	backgroundColor: string;
	borderColor: string;
	cornerStyle: CornerStyle;
	entityData: EntityData;
	extensionLocalId?: string;
	heading: string;
	headingColor: string;
	orientation: Orientation;
	productEntitiesFilter: ProductEntitiesFilter[];
	productEntitySortConfig: ProductEntitySortConfig;
	size: SIZE_VALUES;
	sourceType: SourceType;
	textColor: string;
	version: string;
};

export type JSMHelpActions = {
	updateMainFormField: UpdateMainFormFieldType<JSMHelpParameters>;
};

export type EntityType = {
	id: string;
	name: string;
};

export type Space = {
	id: string;
	name: string;
	projectId: string;
};
